import { BookOpen, Clock3 } from "lucide-react";
import { GuideHeading, LevelSwitch, SourceLink } from "./GuidePrimitives";

export const EducationSection = ({ country, level, setLevel }) => {
  const pathway = country[level];
  return (
    <section id="education" className="guide-section container-x" aria-labelledby="education-heading">
      <GuideHeading number="01" label="Why study here" title={`What ${country.shortName} is known for`} id="education-heading" />
      <p className="max-w-3xl text-base leading-relaxed text-mist" data-testid="country-education-intro">{country.intro}</p>
      <div className="guide-strengths">
        {country.strengths.map(([title, text], i) => (
          <article key={title} data-testid={`education-strength-${i}`}>
            <span className="mb-4 block font-mono text-xs text-[var(--guide-accent)]">0{i + 1}</span>
            <h3 className="mb-3 text-base font-semibold">{title}</h3>
            <p className="text-sm leading-relaxed text-mist">{text}</p>
          </article>
        ))}
      </div>
      <div className="guide-pathway">
        <div className="mb-7 flex flex-wrap items-center justify-between gap-5">
          <h3 className="inline-flex items-center gap-2 text-base font-semibold"><BookOpen size={18} className="text-[var(--guide-accent)]" />Your academic pathway</h3>
          <LevelSwitch level={level} onChange={setLevel} />
        </div>
        <div className="grid gap-7 md:grid-cols-[1fr_1.2fr]" data-testid="guide-pathway-content">
          <div>
            <p className="mb-3 inline-flex items-center gap-2 font-mono text-sm text-[var(--guide-accent)]" data-testid="guide-course-duration"><Clock3 size={16} />{pathway.duration}</p>
            <p className="text-sm leading-relaxed text-mist">{pathway.text}</p>
          </div>
          <div className="border-t border-white/10 pt-6 md:border-l md:border-t-0 md:pl-8 md:pt-0">
            <h4 className="mb-3 text-sm font-semibold">Typical entry requirements</h4>
            <p className="text-sm leading-relaxed text-mist">{pathway.entry}</p>
          </div>
        </div>
        <div className="mt-6"><SourceLink href={country.educationSource[1]} testId="guide-education-source">{country.educationSource[0]}</SourceLink></div>
      </div>
    </section>
  );
};